import { Link } from 'react-router-dom';
import AppHeader from '../AppHeader';
import { Button } from '../ui/button';
import { CheckCircle2, Clock } from 'lucide-react';

const StepSubmitted = ({ listing }) => (
  <div className="min-h-screen bg-background flex flex-col" data-testid="listing-submitted">
    <AppHeader />
    <main className="flex-1 px-5 py-12 sm:py-20">
      <div className="max-w-md mx-auto text-center">
        <div className="mx-auto w-16 h-16 bg-emerald-100 rounded-2xl flex items-center justify-center mb-5">
          <CheckCircle2 className="h-8 w-8 text-emerald-600" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-heading font-extrabold text-slate-900 leading-tight">
          Thanks — we're on it.
        </h1>
        <p className="mt-3 text-base text-slate-600 leading-relaxed">
          We'll review <strong>{listing?.title || 'your listing'}</strong> and let you know
          within 24 hours. You'll get an email the moment a decision is made.
        </p>
        <div className="mt-6 px-4 py-3 bg-amber-50 border border-amber-200/60 rounded-xl text-left flex gap-3">
          <Clock className="h-5 w-5 text-amber-700 flex-shrink-0 mt-0.5" />
          <div className="text-sm text-amber-900 leading-relaxed">
            While we review, your listing stays private. We may reach out if we need a
            document or a clearer photo.
          </div>
        </div>
        <Button asChild className="mt-6 btn-primary w-full h-12">
          <Link to="/home" data-testid="submitted-home-cta">Back to home</Link>
        </Button>
      </div>
    </main>
  </div>
);

export default StepSubmitted;
